<template>
  <div id="addContract">
    <div style="padding: 10px;font-size: 14px;color: #333333;">
      {{$t('deal.contract.addContract.contractNum')}}{{contractNum}}
    </div>
    <div>
      <div class="edit_info">
      <a-form :form="form" layout="inline">
        <a-row>
          <a-form-item :label="$t('dealConfirm.payerType.title')">
            <a-radio-group v-decorator="decorators.customerType" @change="customerTypeChange">
              <a-radio :value="3">{{$t('dealConfirm.payerType.3')}}</a-radio>
              <a-radio :value="1">{{$t('dealConfirm.payerType.1')}}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-row>
      </a-form>
      <a-form :form="form" selfUpdate layout="vertical">
        <a-form-item v-show="false">
          <a-input v-decorator="['dealId']"></a-input>
          <a-input v-decorator="['id']"></a-input>
          <a-input v-decorator="['version']"></a-input>
        </a-form-item>
        <a-row>
          <a-col :span="16">
            <a-form-item :label="$t('deal.contract.addContract.companyName')" class="required">
              <a-select
                showSearch
                v-decorator="decorators.customerId"
                :placeholder="$t('deal.contract.addContract.companyNamePlaceholder')"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handleSearch"
                :notFoundContent="null"
              >
                <a-icon slot="suffixIcon" type="caret-down" />
                <div slot="dropdownRender" slot-scope="menu">
                  <v-nodes :vnodes="menu" />
                  <a-divider style="margin: 0;" />
                  <div class="addCustomerBtn" @click="openAddCustomerModal">
                    <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                    <div style="font-size: 12px;color: #ffffff;margin-left:4px;">{{customerType == 1 ? $t('track.trackModal.addCustomer') : $t('track.trackModal.addProprietor')}}</div>
                  </div>
                </div>
                <a-select-option v-for="d in customerList" :key="d.id" :value="d.id">
                  <div style="display:flex;">
                    <div style="flex:1;" class="invisible-item">
                      {{d.companyName}}
                    </div>
                    <div>
                      {{d.companySortNameCn}}
                    </div>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('deal.contract.addContract.signTime')">
              <a-date-picker style="width:100%;" :placeholder="$t('deal.contract.addContract.signTimePlaceholder')" v-decorator="decorators.signTime"></a-date-picker>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="16">
            <a-form-item :label="$t('deal.contract.addContract.startTime')">
              <a-range-picker style="width:100%;" v-model="dateRange"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('deal.contract.addContract.totalBrokerage')">
              <a-input-group compact>
                <pt-input-number :precision="2" style="width:70%;" v-decorator="decorators.totalBrokerage" :min="0" :max="9999999999"></pt-input-number>
                <pt-unit-select style="width: 30%;" type="currency" v-decorator="decorators.totalBrokerageUnit" disabled></pt-unit-select>
              </a-input-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('deal.contract.addContract.serviceCycle')">
              <a-select
                :placeholder="$t('deal.contract.addContract.serviceCyclePlaceholder')" v-decorator="decorators.serviceCycle"
                showSearch
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                :notFoundContent="null"
              >
                <a-select-option v-for="m in serviceCycleOptions" :key="m.wordKey" :value="m.wordKey">{{m.wordValue}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('deal.contract.addContract.serviceTimes')">
              <pt-input-number
                :placeholder="$t('deal.contract.addContract.serviceTimes')" v-decorator="decorators.serviceTimes"
                :precision="0" :min="0" :max="100" :step="1"
                style="width: 100%;"
              ></pt-input-number>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item :label="$t('deal.contract.addContract.content')">
              <ptInput v-decorator="decorators.content" :max-length="500" type="textarea" :autosize="{minRows:3,maxRows:3}"></ptInput>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      </div>
      <div class="fileRow">
        <div class="fileRowLeft">
          <div class="circle"></div>
          <div class="fileTitle">{{$t('deal.contract.addContract.files')}}</div>
          <div class="fileTip">{{$t('lease.modal.filesTip')}}</div>
        </div>
        <pt-oss-upload @onSuccess="onSuccess">
          <a-button size="small"><pt-icon type="icon-shangchuanfujian"></pt-icon>{{$t('lease.modal.uploadFile')}}</a-button>
        </pt-oss-upload>
      </div>
      <div class="fileDiv">
        <div v-if="fileList.length > 0">
          <div v-for="(item,index) in fileList" :key="index" class="fileItem">
            <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
            <div class="fileName">{{item.fileName}}</div>
            <div @click="delFile(index)">
              <pt-icon class="delIcon" type="icon-tubiao"></pt-icon>
            </div>
          </div>
        </div>
        <div v-else class="noFileClass">
          {{$t('baseVO.empty')}}
        </div>
      </div>
    </div>
    <pt-modal :title="customerType == 1 ? customerModalTitle : proprietorModalTitle" :visible="customerModalVisible || proprietorModalVisible"
              @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
    >
      <div slot="content">
        <add-customer ref="customerModel" v-model="customerModalTitle" @saveSuccess="saveCustomerSuccess" v-if="customerModalVisible"></add-customer>
        <addProprietor v-if="proprietorModalVisible" v-model="proprietorModalTitle" ref="addProprietorRef" @saveSuccess="saveProprietorSuccess"></addProprietor>
      </div>
    </pt-modal>
  </div>
</template>

<script>
  import customerApi from '@/api/mine/customer'
  import contractApi from '@/api/mine/contract'
  import addCustomer from '../../database/customer/module/addCustomer'
  import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
  import { getDatadictChildsByPath } from '@/api/sys/datadict'
  import ownerApi from '@/api/database/owner'
  import AddProprietor from '../../database/proprietor/module/addProprietor'

  export default {
    name: 'addContract',
    props: {
      dealId:{
        type:String,
        default:null,
      },
      dealCustomerType:{
        type:String,
        default:1,
      },
      customerId:{
        type:String,
        default:undefined,
      },
      contractVO:{
        type:Object,
        default:null,
      }
    },
    components:{
      AddProprietor,
      addCustomer,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
    },
    data() {
      return {
        fileList:[],
        customerType:1,
        contractNum:null,
        defaultFormValue:{
          serviceCycle: 'count',
          totalBrokerage: 0,
          signTime: this.$moment(),
          serviceTimes: 1,
        },
        form:this.$form.createForm(this,{}),
        customerList:[],
        serviceCycleOptions:[],
        customerModalVisible: false,
        customerModalTitle:'',
        proprietorModalTitle:'',
        proprietorModalVisible: false,
        dateRange:null,
        decorators:{
          customerType:[
            'customerType',{initialValue: 1}
          ],
          customerId:[
            'customerId',
              {rules:[
                {required: true, message:this.$t('deal.contract.addContract.errorInfo.customerId')},
              ]}
          ],
          signTime:[
            'signTime',[]
          ],
          totalBrokerage:[
            'totalBrokerage',[]
          ],
          totalBrokerageUnit:[
            'totalBrokerageUnit',[]
          ],
          serviceCycle:[
            'serviceCycle',[]
          ],
          serviceTimes:[
            'serviceTimes',[]
          ],
          content:[
            'content',{rules:[
                {max:500,message:'备注最多输入 500 个字',target:['change', 'blur']}
              ]}
          ],
        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      customerTypeChange(value){
        this.customerType = value.target.value
        this.form.setFieldsValue({customerId:undefined})
        this.handleSearch(null)
      },
      cancelAddCustomer(){
        this.proprietorModalVisible = false
        this.customerModalVisible = false;
      },
      delFile(index){
        this.fileList.splice(index,1);
      },
      init(){
        this.initDefaultRentUnit()
        this.initServiceCycleOptions()
        this.initFormDefaultValue()
      },
      handleSearch(customerName){
        setTimeout(()=>{
          if(!customerName){
            this.customerList = []
            return
          }
          let this_ = this
          if(this.customerType == 1){
            customerApi.queryByName({name: customerName}).then(res => {
              this_.customerList = res.data
            })
          }else{
            ownerApi.queryByName({name:customerName}).then(res=>{
              if(res.code == 1){
                this_.customerList = res.data != null ? res.data : []
              }else{
              }
            })
          }
        },300);
      },
      initCustomerOptions(id){
        let this_ = this
        if(this.contractVO.customerType == 1){
          let p = new Promise((resolve,reject)=>{
            customerApi.selectOne(id).then(res=>{
              if(res.code == 1){
                this_.customerList = [res.data]
                resolve()
              }else{
                reject()
              }
            })
          })
          return p
        }else{
          let p = new Promise((resolve,reject)=>{
            ownerApi.selectOne(id).then(res=>{
              if(res.code == 1){
                this_.customerList = [res.data]
                resolve()
              }else{
                reject()
              }
            })
          })
          return p
        }
      },
      initDefaultRentUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.CURRENCY).then(res=>{
            if(res.code == 1){
              this.form.setFieldsValue({totalBrokerageUnit:res.data[0]})
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initFormDefaultValue(){
        if(!this.contractVO){
          this.contractVO ={customerType: this.dealCustomerType}
          this.defaultFormValue.customerType = this.dealCustomerType
          this.defaultFormValue.customerId = this.customerId
          this.initCustomerOptions(this.customerId).then(()=>{
            this.form.setFieldsValue(this.defaultFormValue)
          })
          this.initContractNum()
        }else{
          let contractVO = JSON.parse(JSON.stringify(this.contractVO))
          this.contractNum = contractVO.contractNum
          this.customerType = contractVO.customerType;
          this.initCustomerOptions(contractVO.customerId).then(()=>{
            contractVO.signTime = this.$moment(contractVO.signTime)
            if(contractVO.startTime != '~'){
              this.dateRange = [this.$moment(contractVO.startTime), this.$moment(contractVO.endTime)]
            }else{
              this.dateRange = []
            }
            this.form.setFieldsValue(contractVO)
            this.fileList = contractVO.fileDOList != null ? contractVO.fileDOList : []
          })
        }
      },
      initContractNum(){
        let this_ = this
        contractApi.getContractNum().then(res=>{
          if(res.code == 1){
            this_.contractNum = res.data
          }else{
            this_.$message.error(res.message)
          }
        })
      },
      initServiceCycleOptions(){
        let this_ = this
        getDatadictChildsByPath('system.business_key.contract.serviceCycle').then(res=>{
          this_.serviceCycleOptions = res.data
        })
      },
      openAddCustomerModal(){
        if(this.customerType == 1){
          this.customerModalVisible = true;
        }else{
          this.proprietorModalVisible = true
        }
      },
      onSuccess(file,fileId){
        this.fileList.push({id:fileId,fileName:file.name})
      },
      saveCustomer(){
        if(this.customerType == 1) {
          this.$refs.customerModel.submit();
        }else{
          this.$refs.addProprietorRef.submit()
        }
      },
      saveCustomerSuccess(id,name){
        this.setDefaultCustomerDO(id,name);
        this.customerModalVisible = false;
      },
      setDefaultCustomerDO(id,name){
        this.customerList = [];
        let customerDO = {
          id:id,
          companyName:name
        }
        this.customerList.push(customerDO);
        this.form.setFieldsValue({
          customerId: id
        })
      },
      saveProprietorSuccess(id,name){
        this.setDefaultCustomerDO(id,name);
        this.proprietorModalVisible = false;
      },
      saveContract(){
        let this_ = this
        this.form.validateFields(err=>{
          if(!err){
            let contractDO = this.form.getFieldsValue()
            contractDO.fileDOLIst = this_.fileList
            if(this_.dateRange != null && this_.dateRange.length > 0){
              contractDO.startTime = this_.dateRange[0].format('YYYY-MM-DD')
              contractDO.endTime = this_.dateRange[1].format('YYYY-MM-DD')
            }
            contractDO.contractNum = this_.contractNum
            if(!this_.contractVO.id){
              contractDO.dealId = this_.dealId
              contractApi.insert(contractDO).then(res=>{
                if(res.code == 1){
                  this.$message.success(res.message)
                  this.$emit('saveContractSuccess')
                }else{
                  this.$message.error(res.message)
                  this.$emit('validateFail')
                }
              })
            }else{
              //更新合同
              contractApi.update(contractDO).then(res=>{
                if(res.code == 1){
                  this.$message.success(res.message)
                  this.$emit('saveContractSuccess')
                }else{
                  this.$message.error(res.message)
                  this.$emit('validateFail')
                }
              })
            }
          }else{
            this.$emit('validateFail')
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #addContract{
    .ant-form-item{
      padding: 0 10px;
    }
    .edit_info{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .fileRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 10px;
      .fileRowLeft{
        display: flex;
        flex-direction: row;
        align-items: center;
        .circle{
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #FABE00;
        }
        .fileTitle{
          font-size: 14px;
          color: #333333;
          margin-left: 10px;
        }
        .fileTip{
          font-size: 12px;
          color: #999999;
          margin-top: 4px;
          margin-left: 4px;
        }
      }
    }
    .fileDiv{
      padding: 0 20px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .fileItem{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;
      .fileIcon{
        font-size: 20px;
      }
      .fileName{
        flex:1;
        font-size: 12px;
        color: #333333;
        margin: 0 20px;
      }
      .delIcon{
        font-size: 20px;
        cursor: pointer;
      }
    }
    .fileItem:last-child{
      border-bottom: 0px;
    }
    .noFileClass{
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #999999;
    }
  }

  .addCustomerBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
  }

  /deep/.invisible-item{
    display:none;
  }

  .ant-select-dropdown-content{
    /deep/.invisible-item{
      display:initial !important;
    }
  }



</style>

